$(document).ready(function(){
    var smallWindow = false;
});
$("body").scroll(function(){
    var scroll = $("body").scrollTop();
    // scroll greater than 50
    if (scroll >= 50) {
        $('#logo-image').attr('width', '180px');
        $(".important-class").addClass("padding-on-my-header");
    }
    // scroll between 0 and 50
    if (scroll < 50) {
        $(".important-class").removeClass("padding-on-my-header").delay(0).queue(function(next){
            $('#logo-image').attr('width', ''); //reset to max-width
            next();
        });
    }
}).resize(function(){
    if (!smallWindow && this.innerWidth <= 1024) {
        smallWindow = true;
        $('.top-bar-section').find('ul.right').hide(0).delay(500).show(0);
    }
    if (smallWindow && this.innerWidth > 1024) {
        smallWindow = false;
    }
});

// Configure/customize these variables.
var showChar = 358;  // How many characters are shown by default
var ellipsestext = "...";
var moretext = "Show more &raquo;";
var lesstext = "Show less &#8689";

$('.more').each(function() {
    if($(this).text().length > showChar){

        var description = $(this).text();
        var descriptionShort = description.substring(0,showChar);
        var descriptionLong = description.substr(showChar, description.length - showChar);

        var html = descriptionShort + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent"><span>' + descriptionLong + '</span>&nbsp;&nbsp;<a href="" class="morelink right">' + moretext + '</a></span>';

        $(this).html(html);
    } else {
        $(this).html($(this).text());
    }
});

$(".morelink").click(function(){
    if($(this).hasClass("less")) {
        $(this).removeClass("less");
        $(this).html(moretext);
    } else {
        $(this).addClass("less");
        $(this).html(lesstext);
    }
    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
});
